import { render, staticRenderFns } from "./MixinAdmin.vue?vue&type=template&id=db607ab6&scoped=true&lang=html&"
import script from "./MixinAdmin.vue?vue&type=script&lang=js&"
export * from "./MixinAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db607ab6",
  null
  
)

export default component.exports